// Module
var code = "<p> <label>resolution X</label> <input type=\"range\" min=\"0\" max=\"64\" step=\"1\" oninput=\"sphere.p.resolution.x.set(event.target.value)\"> </p> <p> <label>resolution Y</label> <input type=\"range\" min=\"0\" max=\"64\" step=\"1\" oninput=\"sphere.p.resolution.y.set(event.target.value)\"> </p>";
// Exports
export default code;